let $filterItems,
    $searchInput,
    $postsContainer,
    $filterContainer,
    $paginationContainer,
    $loaders,
    $pagination,
    $filterPopup,
    $toggleFilterPopup,
    $filterShowMore,
    $filterHiddenItems,
    $filterHiddenBlock,
    $filterReset,
    $filterIsSelected,

    filterGroups = [],
    currentPage = 1,
    firstLoad = true,

    post_type,
    search_value = '',
    filters = [],
    open_filters = [],
    queryString = window.location.search,
    urlParams = new URLSearchParams(queryString);

$(document).ready(function ($) {
    $postsContainer = $('.js-posts-container');
    $filterContainer = $('.js-filter-container');
    $paginationContainer = $('.js-pagination-container');
    $loaders = $('.js-loader');


    getUrlParams();

    if ($postsContainer.length !== 0 && firstLoad) {
        post_type = $postsContainer.data('pt');
        initFunctions();
        getPosts();
        firstLoad = false;

    }
});

function getPosts() {
    $loaders.addClass('is_loading');

    $.ajax({
        url: linku_ajax_url,
        type: 'post',
        data: {
            action: 'load_posts',
            post_type: post_type,
            filters: filters,
            search_value: search_value,
            paged: currentPage,
            filter_group_state: filterGroups
        },
        dataType: 'json',
        success: function (response) {
            $postsContainer.html(response.postsHtml);
            $filterContainer.html(response.filtersHtml);
            $paginationContainer.html(response.paginationHtml);
            $loaders.removeClass('is_loading');
            initFunctions();
        },
        error: function (response) {
            console.log('error', response);
        }
    });
}


function initFunctions() {
    $filterItems = $('.js-filter-item');
    $pagination = $('.js-pagination');
    $toggleFilterPopup = $('.js-toggle-filter-popup');
    $filterPopup = $('.js-filter-popup');
    $filterShowMore = $('.js-filter-show-more');
    $filterHiddenItems = $('.js-filter-hidden-items');
    $filterHiddenBlock = $('.js-filter-hidden-block');
    $searchInput = $('.js-filter-search');
    $filterReset = $('.js-clear-filters');
    $filterIsSelected = $('.js-is-selected');

    $filterShowMore.prev().css('display', 'none')

    $filterIsSelected.parents('.c-filters__hidden-items').css('display', 'block');
    $filterIsSelected.parents('.js-filter-hidden-block').find('.js-filter-show-more').html('Toon minder -');


    $filterItems.on('click', function () {
        const filter = $(this).data('filter');

        if (filters.includes(filter)) {
            filters = filters.filter(item => item !== filter);
        } else {
            filters.push(filter);
        }

        currentPage = 1;
        getPosts();
        updateUrl();
    });

    $pagination.on('click', function (e) {
        $('html, body').animate({
            scrollTop: $postsContainer.offset().top - 200
        }, 'slow');
        if ($(this).data().page === 'prev') {
            currentPage = currentPage - 1;
        } else if ($(this).data().page === 'next') {
            currentPage = currentPage + 1;
        } else {
            currentPage = Number($(this).data().page);
        }
        updateUrl();
        getPosts();
    });

    $toggleFilterPopup.on('click', function (e) {
        $filterPopup.each(function () {
            if ($(this).hasClass('is-open')) {
                $body.removeClass('menu-is-open');
                $(this).fadeOut().removeClass("is-open");
            } else {
                $(this).fadeIn().addClass("is-open");
                $body.addClass('menu-is-open');
            }
        });
    });

    $filterShowMore.on('click', function () {
        let id = $(this).data('taxid');
        setFilterGroupState(id);
        $(this).prev().slideToggle();
        if ($(this).is(':contains("Toon minder -")')) {
            $(this).html('Toon meer +');
        } else {
            $(this).html('Toon minder -');
        }
    })

    $filterHiddenBlock.each(function () {
        let open = ($(this).data('isopen') == 1);
        let id = $(this).data('taxid');
        if (!filterGroups.some(filterGroup => filterGroup.id === id)) {
            filterGroups.push({
                id: id,
                open: open
            });
        }
        setFilterGroupState(id, true);
    })

    $searchInput.on('keyup', function (e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            // reset paged
            currentPage = 1;
            search_value = $searchInput.val();
            getPosts();
            updateUrl();
        }
    });
    $searchInput.val(search_value);

    $filterReset.on('click', function (e) {

        currentPage = 1;
        filters = [];
        getPosts();
        updateUrl();
    });
}

function setFilterGroupState(id, initial = false) {
    let filterGroup = filterGroups.find(x => x.id === id)
    if (!initial) {
        filterGroup.open = !filterGroup.open;
    }
}

function getFilterGroupState(id) {
    return filterGroups.find(x => x.id === id).open
}

function updateUrl() {
    urlParams.delete('terms');
    for (let i in filters) {
        let term = filters[i].split(".").pop();
        urlParams.append('terms', term);
    }
    urlParams.set('page', currentPage);
    urlParams.set('s', search_value);
    window.history.replaceState({}, '', `${location.pathname}?${urlParams}`);
}

function getUrlParams() {
    if (urlParams.has('terms')) {
        filters = urlParams.getAll('terms');
        for (let i in filters) {
            filters[i] = 'term.' + filters[i];
        }
    }
    if (urlParams.has('page')) {
        currentPage = urlParams.get('page');
    }
    if (urlParams.has('s')) {
        search_value = urlParams.get('s');
    }


}

function search() {
    search_value = $searchInput.val();
    updateUrl();
    getPosts();

}
